<div class="not-wrapper">
  <div class="item-container notification-search">
    <p>{{translationService.translate('galis_js_notification_center_show')}}:</p>
    <p class="options">{{translationService.translate('galis_js_notification_center_open_options')}}</p>

    <div class="separator"></div>

    <p class="archive">{{translationService.translate('galis_js_notification_center_archive')}}</p>
    <input type="text" placeholder="{{translationService.translate('galis_js_notification_center_search_by_keyword')}}" />

    <p>{{translationService.translate('galis_js_notification_center_actiontype')}}</p>
    <input type="text" class="search-dd" placeholder="{{translationService.translate('galis_js_notification_center_all')}}" />

    <p>{{translationService.translate('galis_js_notification_center_sort')}}</p>
    <input type="text" class="search-dd" placeholder="{{translationService.translate('galis_js_notification_center_recent/descending')}}" />
  </div>

  <div class="containers under-not">

    @if (currentItem != null) {
      <div class="side-popup">
        <div class="top-bar">
          @if (showButtons == true) {
            <p>{{translationService.translate('galis_js_notification_center_approval_required')}}</p>
          }
          <!--<div class="toolbar-actions">
          <div class="search"></div>
          <div class="separator"></div>
          <div class="download"></div>
          <div class="separator"></div>
          <div class="delete"></div>
          <div class="separator"></div>
          <div class="add"></div>
        </div>-->
      </div>
      <!-- -------------------------------------------------------   SIDE CONTENT -------------------------------------------------------------->
      <div class="popup-inner-content popuptask">
        <h1>{{currentItem.Title}}</h1>
        @if (checkDateCreated(currentItem)) {
          <p class="underline">{{translationService.translate('galis_js_notification_center_created')}}: {{currentItem.DateCreated | date: 'dd.MM.yyyy'}}</p>
        }
        @if (checkDueDate(currentItem)) {
          <p class="underline">{{translationService.translate('galis_js_notification_center_duedate')}}: {{currentItem.DueDate | date: 'dd.MM.yyyy'}}</p>
        }
        <p class="text"></p>
        <div class="text description" [innerHTML]="currentItem.Description"></div>
        @if (dynComp.model) {
          <div class="file-holder">
            @for (file of dynComp.model.Medias; track file) {
              <div class="sub-side-content">
                <div class="attachment">
                  <div class="img"></div>
                </div>
                <p>{{file.Name}}</p>
              </div>
            }
          </div>
        }
        <!--
        <textarea placeholder="Add comments..."></textarea>
        -->
        <app-sem-dynamic-control #dynComp (modelChanged)="modelChanged($event)" [url]="currentItem.FormName"
        [entityId]="currentItem.EntityID"></app-sem-dynamic-control>
        @if (showButtons) {
          <div class="btn-group">
            <button (click)="accept()" class="accept">{{translationService.translate('galis_js_notification_center_accept')}}
              @if (acceptDD && currentItem.TaskOutcomes.length > 1) {
                <div class="dd">
                  @for (taskoutcome of currentItem.TaskOutcomes; track taskoutcome) {
                    <p (click)="executeOutcome(taskoutcome)">
                    {{taskoutcome.Title}}</p>
                  }
                </div>
              }
            </button>
            <button (click)="decline()" class="decline">{{translationService.translate('galis_js_notification_center_decline')}}</button>
          </div>
        }
      </div>
    </div>
  }
  <!-- -------------------------------------------------------   SIDE CONTENT -------------------------------------------------------------->

  <div class="container-wrapper notifications">


    <!-- <div class="select-all">
    <input class="sem-noti-check-box" type="checkbox" />
    <p>Select all</p>
  </div>

  <div class="nav-line">

    <p class="applied-filters">Applied filters: </p>

    <div class="inlined">
      <p>Action type: <span>Task</span></p>
      <div class="separator"></div>
      <p>Sort: <span>Ascending</span></p>
    </div>

    <button>Accept all</button>
    <button>Decline all</button>

  </div> -->

  <h1 class="table-header">{{ today | date : 'dd.MM.yyyy'}}</h1>
  <table class="task-table">
    <thead>
      <th>
        <p>{{translationService.translate('galis_js_notification_center_task')}}</p>
      </th>
      <th>
        <p>{{translationService.translate('galis_js_notification_center_statustask')}}</p>
      </th>
      <th>
        <p>{{translationService.translate('galis_js_notification_center_taskcreated')}}</p>
      </th>
      <th>
        <p>{{translationService.translate('galis_js_notification_center_taskdeadline')}}</p>
      </th>
      <th>
        <p>{{translationService.translate('galis_js_notification_center_taskfiles')}}</p>
      </th>
      <th></th>
    </thead>
    <tbody>
      @for (task of items; track task) {
        <tr>
          <td>
            @if (task.Complete == false || task.CanOpenIfComplete == true) {
              <input class="sem-noti-check-box" type="checkbox" (click)="itemSelected($event, task)"
                />
            }
            <p [ngClass]="{'task-opened': checkIfOpened(task) == true, 'task-unread': checkIfOpened(task) == false}">{{task.Title}}</p>
          </td>
          <td>
            @if (task.Complete == false) {
              <p>{{translationService.translate('galis_js_notification_center_incomplete')}}</p>
            }
            @if (task.Complete == true) {
              <p>{{translationService.translate('galis_js_notification_center_complete')}}</p>
            }
          </td>
          <td>
            <p>{{task.DateCreated | date: 'dd.MM.yyyy':'CET'}}</p>
          </td>
          <td>
            <p>{{task.DueDate | date: 'dd.MM.yyyy':'CET'}}</p>
          </td>
          <td>
            @for (taskFile of task.TaskFiles; track taskFile) {
              <p>
                <span class="task-file" (click)="downloadTaskFile(task)">{{taskFile.FileName}}</span>
              </p>
            }
          </td>
          <td>
            {{task.Entity["Title"]}}
          </td>
        </tr>
      }

    </tbody>
    <tfoot>
      <tr>
        <td class="task-paging" colspan="4">
          @for (number of paging; track number) {
            <p (click)="loadItemsPage(number)" [ngClass]="{'selected-page': number==currentPage}">
              {{number}}
            </p>
          }
        </td>
      </tr>
    </tfoot>
  </table>
</div>
</div>
</div>